/**
 * Google Analytics 4 service
 * Uses Consent Mode v2 — events only sent after user grants analytics consent.
 */

const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

/**
 * Updates GA consent state. Call after user interaction with cookie banner.
 * @param {boolean} granted - whether user accepted analytics tracking
 */
export const updateAnalyticsConsent = (granted) => {
  if (!isGtagAvailable()) return;
  window.gtag('consent', 'update', {
    'analytics_storage': granted ? 'granted' : 'denied',
    'ad_storage': granted ? 'granted' : 'denied',
    'ad_user_data': granted ? 'granted' : 'denied',
    'ad_personalization': granted ? 'granted' : 'denied'
  });
};

/**
 * Track a custom GA4 event.
 * @param {string} eventName - GA4 event name (snake_case)
 * @param {object} params - optional event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (!isGtagAvailable()) return;
  window.gtag('event', eventName, params);
};

// Named event helpers for the landing page
export const analytics = {
  leadCapture: (source = 'email_capture') =>
    trackEvent('lead_capture', { source }),

  shareClick: (channel, source) =>
    trackEvent('share', { method: channel, content_type: source }),

  startTest: () => trackEvent('start_test'),

  completeTest: (profile, score) =>
    trackEvent('complete_test', { profile, score }),

  goalCalculated: (goalName, amount, years) =>
    trackEvent('goal_calculated', { goal_name: goalName, amount, years }),

  savingsIndexCalculated: (percentage) =>
    trackEvent('savings_index_calculated', { percentage }),

  accept30DayChallenge: (category) =>
    trackEvent('accept_30day_challenge', { category }),

  accept18MonthChallenge: () =>
    trackEvent('accept_18month_challenge'),

  ctaClick: (ctaName) =>
    trackEvent('cta_click', { cta_name: ctaName }),

  faqOpen: (questionId) =>
    trackEvent('faq_open', { question_id: questionId })
};
